import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Marquee from "@/components/Marquee";
import { NewsletterSection } from "@/components/NewsletterForm";
import { PageIntro, FadeUp } from "@/components/Reveal";
import { PatchBadge, Squiggle, Spark } from "@/components/Doodles";
import { useContent } from "@/context/ContentContext";

const About = () => {
    const { t } = useContent();
    return (
        <>
            <Seo
                title="About"
                description="The story of Panther City Clubhouse — neighbors building a permanent, member-supported clubhouse in Richland Hills, TX."
            />
            <PageIntro kicker="once upon a time in richland hills" title="ABOUT THE CLUBHOUSE" intro={t("about.intro", "")} />
            <section className="px-5 pb-16 sm:px-10">
                <div className="mx-auto grid max-w-6xl items-start gap-10 lg:grid-cols-[1.4fr_1fr]">
                    <FadeUp>
                        <div className="border-2 border-ink bg-paper p-8 hard-shadow-lg -rotate-[0.5deg] sm:p-10">
                            <p className="text-lg leading-relaxed text-ink/80">{t("about.body", "")}</p>
                            <Squiggle className="mt-8 h-5 w-48 text-orange" />
                            <p className="mt-6 font-hand text-2xl text-brick -rotate-1 sm:text-3xl">
                                currently: renovating, fundraising, and stapling things to corkboards at record pace.
                            </p>
                        </div>
                    </FadeUp>
                    <FadeUp delay={0.15} className="flex flex-col items-center gap-6">
                        <PatchBadge className="h-48 w-48 rotate-3 text-forest" />
                        <div className="flex items-center gap-3">
                            <Spark className="h-6 w-6 text-mustard" />
                            <Spark className="h-9 w-9 text-orange" />
                            <Spark className="h-6 w-6 text-brick" />
                        </div>
                        <Link to="/contact" data-testid="about-cta-visit" className="btn-stamp">
                            Come to the Clubhouse
                        </Link>
                    </FadeUp>
                </div>
            </section>
            <section data-testid="about-org" className="border-y-2 border-ink bg-forest px-5 py-16 text-cream sm:px-10 sm:py-20">
                <div className="mx-auto max-w-4xl">
                    <FadeUp>
                        <p className="font-hand text-2xl text-mustard -rotate-2 sm:text-3xl">no mystery meat</p>
                        <h2 className="mt-1 font-display text-4xl tracking-wide sm:text-5xl">{t("about.org_heading", "WHO ACTUALLY RUNS THIS PLACE")}</h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="mt-8 grid gap-6 sm:grid-cols-2">
                        <div className="border-2 border-cream/40 bg-ink/20 p-6 -rotate-[0.5deg]">
                            <h3 className="font-display text-xl tracking-wider text-mustard">PANTHER CITY CLUBHOUSE LLC</h3>
                            <p className="mt-2 text-sm leading-relaxed text-cream/85">{t("about.org_llc", "")}</p>
                        </div>
                        <div className="border-2 border-cream/40 bg-ink/20 p-6 rotate-[0.5deg]">
                            <h3 className="font-display text-xl tracking-wider text-mustard">THE CLUBHOUSE ALLIANCE</h3>
                            <p className="mt-2 text-sm leading-relaxed text-cream/85">{t("about.org_alliance", "")}</p>
                        </div>
                    </FadeUp>
                    <FadeUp delay={0.18}>
                        <p className="mt-8 max-w-2xl leading-relaxed text-cream/85">{t("transparency.body", "")}</p>
                        <Link to="/transparency" data-testid="about-transparency-link" className="btn-stamp mt-6 inline-block !bg-mustard !text-ink">
                            See the Books →
                        </Link>
                    </FadeUp>
                </div>
            </section>
            <Marquee />
            <NewsletterSection idPrefix="about-newsletter" />
        </>
    );
};

export default About;
